import React, { useState, useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useStoreState } from 'easy-peasy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import marketing from '../../../../../services/marketing';
import { tcGenerator } from '../../../../../services/tcGenerator';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function PlaidTerms({props}) {
    const setting = useStoreState(state => state.siteSettingsModel);
    const [Template, setTemplate] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [numPages, setNumPages] = useState(0);
    const [pageWidth, setPageWidth] = useState(0);
    const pdfContainerRef = useRef(null);
    const applicationResult = useStoreState(state => state.applicationResultModel.applicationResult);
    const utm = new marketing();
    const isMountedRef = useRef(true);

    useEffect(() => {
        const updatePageWidth = () => {
            if (pdfContainerRef.current) {
                setPageWidth(pdfContainerRef.current.clientWidth - 2);
            }
        };
    
        updatePageWidth();
        window.addEventListener("resize", updatePageWidth);
    
        return () => window.removeEventListener("resize", updatePageWidth);
    }, [props.showPlaidTerms, Template]);

    useEffect(() => {
        return () => { isMountedRef.current = false; };
    }, []);

    useEffect(() => {
        if (props.showPlaidTerms) {
            getTemplate();
        }
    }, [props.showPlaidTerms]);

    const getTemplate = async () => {
        const PC = applicationResult.alternate_product_code || applicationResult.product_code || setting.mainSettings.ProductCode;

        setTemplate("");
        setErrorMessage("");

        try {
            const { fileContent, hasErrors, errorMessage } = await tcGenerator(PC);
            if (!isMountedRef.current) return;

            if (hasErrors) return setErrorMessage(errorMessage);
            setTemplate(fileContent);
        } catch {
            if (!isMountedRef.current) return;
            setErrorMessage("Unknown Error");
        }
    }

    const handleOpenTerms = async (e) => {
        e.preventDefault();
        utm.updateSessionReport("disclosureLink");

        const byteCharacters = atob(Template);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);

        window.open(blobUrl, "_blank");
    }

    return (
        <Modal show={props.showPlaidTerms} onHide={() => props.setShowPlaidTerms(false)} dialogClassName="modal-80w">
            <Modal.Header>
                <Modal.Title>Terms and Conditions</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div id="applicant-disclosure" style={{ maxHeight: "none" }}>
                    {Template ? (
                        
                        <div 
                            ref={pdfContainerRef} 
                            style={{
                                height: "45vh",
                                maxHeight: "450px",
                                overflowX: "hidden",
                                overflowY: "auto",
                                border: "1px solid #ddd",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            }}
                        >
                            <Document
                                file={`data:application/pdf;base64,${Template}`}
                                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                            >
                                {pageWidth > 0 && Array.from(new Array(numPages), (_, index) => (
                                    <Page
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1}
                                        width={pageWidth}
                                    />
                                ))}
                            </Document>
                        </div>

                    ) : (
                        <div>{errorMessage}</div>
                    )}
                </div>
                <div className="terms-print">
                    <button type="button" className="button-link" onClick={handleOpenTerms}>
                        <FontAwesomeIcon icon={faPrint} /> &nbsp; Rates, Fees, Costs and Limitations
                    </button>
                </div>
            </Modal.Body>
            <Modal.Footer className="text-center">
                <Button variant="primary" style={{ backgroundColor: setting.brandSettings.Secondary, minWidth: "200px" }} onClick={() => props.setShowPlaidTerms(false)}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default PlaidTerms